import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import Select from "../../../../../../../components/select/Select";
import stylesInput from "../../../../../../../components/textbox/Input.module.css"
import $ from 'jquery';

class CaratteristicheDellaMalattiaTubercolosi extends Component {

    state = {
        caratteristicheDellaMalattia: {
            dataInizioTerapiaAntitubercolare: "",
            diagnosiInPassato: "",
            eventualeDataDiagnosiInPassato: "",
            classificazioneNuovo: "",
            classificazioneVecchio:"",
            classificazioneVecchioInterrotto: "",
            agenteEziologico: "",
            agenteEziologicoAltro: "",
            polTrachBron: "",
            extraPolmonare: "",
            localizzazione1: "",
            localizzazione2: "",
            diseminata: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni,
        province: JSON.parse(sessionStorage.getItem("province")),
    }


    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this);
        this.pulisciRow = this.pulisciRow.bind(this);
    }

    componentDidMount() {
        let caratteristicheDellaMalattia = this.state.caratteristicheDellaMalattia

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia) {
            let caratteristicheDellaMalattiaProps = this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia
            caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare = caratteristicheDellaMalattiaProps.dataInizioTerapiaAntitubercolare ? caratteristicheDellaMalattiaProps.dataInizioTerapiaAntitubercolare : this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare
            caratteristicheDellaMalattia.diagnosiInPassato = caratteristicheDellaMalattiaProps.diagnosiInPassato ? caratteristicheDellaMalattiaProps.diagnosiInPassato : this.state.caratteristicheDellaMalattia.diagnosiInPassato
            caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato = caratteristicheDellaMalattiaProps.eventualeDataDiagnosiInPassato ? caratteristicheDellaMalattiaProps.eventualeDataDiagnosiInPassato : this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato
            caratteristicheDellaMalattia.classificazioneNuovo = caratteristicheDellaMalattiaProps.classificazioneNuovo ? caratteristicheDellaMalattiaProps.classificazioneNuovo : this.state.caratteristicheDellaMalattia.classificazioneNuovo
            caratteristicheDellaMalattia.classificazioneVecchio = caratteristicheDellaMalattiaProps.classificazioneVecchio ? caratteristicheDellaMalattiaProps.classificazioneVecchio : this.state.caratteristicheDellaMalattia.classificazioneVecchio
            caratteristicheDellaMalattia.classificazioneVecchioInterrotto = caratteristicheDellaMalattiaProps.classificazioneVecchioInterrotto ? caratteristicheDellaMalattiaProps.classificazioneVecchioInterrotto : this.state.caratteristicheDellaMalattia.classificazioneVecchioInterrotto
            caratteristicheDellaMalattia.agenteEziologico = caratteristicheDellaMalattiaProps.agenteEziologico ? caratteristicheDellaMalattiaProps.agenteEziologico : this.state.caratteristicheDellaMalattia.agenteEziologico
            caratteristicheDellaMalattia.agenteEziologicoAltro = caratteristicheDellaMalattiaProps.agenteEziologicoAltro ? caratteristicheDellaMalattiaProps.agenteEziologicoAltro : this.state.caratteristicheDellaMalattia.agenteEziologicoAltro
            caratteristicheDellaMalattia.polTrachBron = caratteristicheDellaMalattiaProps.polTrachBron ? caratteristicheDellaMalattiaProps.polTrachBron : this.state.caratteristicheDellaMalattia.polTrachBron
            caratteristicheDellaMalattia.extraPolmonare = caratteristicheDellaMalattiaProps.extraPolmonare ? caratteristicheDellaMalattiaProps.extraPolmonare : this.state.caratteristicheDellaMalattia.extraPolmonare
            caratteristicheDellaMalattia.localizzazione1 = caratteristicheDellaMalattiaProps.localizzazione1 ? caratteristicheDellaMalattiaProps.localizzazione1 : this.state.caratteristicheDellaMalattia.localizzazione1
            caratteristicheDellaMalattia.localizzazione2 = caratteristicheDellaMalattiaProps.localizzazione2 ? caratteristicheDellaMalattiaProps.localizzazione2 : this.state.caratteristicheDellaMalattia.localizzazione2
            caratteristicheDellaMalattia.diseminata = caratteristicheDellaMalattiaProps.diseminata ? caratteristicheDellaMalattiaProps.diseminata : this.state.caratteristicheDellaMalattia.diseminata
        }
        this.setState({caratteristicheDellaMalattia: caratteristicheDellaMalattia});
        this.controlloCorrettezza()
        let oggetto = this.createOggettoBE()
        this.props.setCaratteristicheDellaMalattiaTubercolosi(this.state.caratteristicheDellaMalattia, "", oggetto, this.controlloCorrettezza)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setCaratteristicheDellaMalattiaTubercolosi(this.state.caratteristicheDellaMalattia, this.validate(), res)
        }
        this.disabledAgenteEziologico()

    }

    disabledAgenteEziologico() {
        let carDiagnosi = this.props.caratteristicheDellaDiagnosiTubercolosi
        if (carDiagnosi.esameColturaleEscreato !== "1" && carDiagnosi.esameColturaleAltroMateriale !== "1") {
            $('input[name="agenteEziologico"]').attr('disabled', 'disabled');
        } else {
            $('input[name="agenteEziologico"]').removeAttr('disabled');
        }
    }

    validate() {

        if (this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare && Utils.validateDate(this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare, "Messages.DataAntitubercolare", "Messages.DataAntitubercolareOdierna")) {
            return Utils.validateDate(this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare, "Messages.DataAntitubercolare", "Messages.DataAntitubercolareOdierna")
        }
        if (this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato && Utils.validateDate(this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato, "Messages.DataDiagnosiPassato", "Messages.DataDiagnosiPassatoOdierna")) {
            return Utils.validateDate(this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato, "Messages.DataDiagnosiPassato", "Messages.DataDiagnosiPassatoOdierna")
        }
        return ""

    }

    riceviValore(field, event) {
        let caratteristicheDellaMalattia = this.state.caratteristicheDellaMalattia
        let carDiagnosi = this.props.caratteristicheDellaDiagnosiTubercolosi
        caratteristicheDellaMalattia[field] = event.target.value
        if (caratteristicheDellaMalattia.diagnosiInPassato === "2" ||
            caratteristicheDellaMalattia.diagnosiInPassato === "3") {
            caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato = ""
        }
        if (caratteristicheDellaMalattia.extraPolmonare === "false") {
            caratteristicheDellaMalattia.localizzazione1 = caratteristicheDellaMalattia.localizzazione2 = ""
        }

        if (caratteristicheDellaMalattia.agenteEziologico !== "6") {
            caratteristicheDellaMalattia.agenteEziologicoAltro = ""
        }
        if (carDiagnosi.esameColturaleEscreato !== "1" && carDiagnosi.esameColturaleAltroMateriale !== "1") {
            caratteristicheDellaMalattia.agenteEziologico = ""
        }
        if(field === "classificazioneNuovo"){
            caratteristicheDellaMalattia.classificazioneVecchio = "false"
            caratteristicheDellaMalattia.classificazioneVecchioInterrotto = "false"
        }
        if(field === "classificazioneVecchio"){
            caratteristicheDellaMalattia.classificazioneNuovo = "false"
            caratteristicheDellaMalattia.classificazioneVecchioInterrotto = "false"
        }
        if(field === "classificazioneVecchioInterrotto"){
            caratteristicheDellaMalattia.classificazioneNuovo = "false"
            caratteristicheDellaMalattia.classificazioneVecchio = "false"
        }
        this.setState({caratteristicheDellaMalattia: caratteristicheDellaMalattia})
        this.controlloCorrettezza()
        let oggetto = this.createOggettoBE()
        this.props.setCaratteristicheDellaMalattiaTubercolosi(this.state.caratteristicheDellaMalattia, undefined, oggetto)
    }

    controlloCorrettezza() {
        let caratteristiche = this.state.caratteristicheDellaMalattia
        let carDiagnosi = this.props.caratteristicheDellaDiagnosiTubercolosi
        caratteristiche.corretto = []

        if ((carDiagnosi.esameColturaleEscreato === "1" || carDiagnosi.esameColturaleAltroMateriale === "1") && (!caratteristiche.agenteEziologico || (caratteristiche.agenteEziologico === "6" && !caratteristiche.agenteEziologicoAltro))) caratteristiche.corretto[0] = "Campo \"Agente Eziologico\" mancante";
        if(!caratteristiche.dataInizioTerapiaAntitubercolare ||
            Utils.isDateInValid(Utils.transformDateForBackend(caratteristiche.dataInizioTerapiaAntitubercolare), "-")) caratteristiche.corretto[1] = "Campo \"Data Inizio Terapia Antitubercolare\" mancante o errato";
        if(!caratteristiche.diagnosiInPassato ||
            (caratteristiche.diagnosiInPassato === "1" && (!caratteristiche.eventualeDataDiagnosiInPassato ||
            Utils.isDateInValid(Utils.transformDateForBackend(caratteristiche.eventualeDataDiagnosiInPassato), "-")))) caratteristiche.corretto[2] = "Campo \"Ha avuto diagnosi di tubercolosi in passato?\" mancante o errato";
        if(((!caratteristiche.polTrachBron || caratteristiche.polTrachBron === "false") &&
            (!caratteristiche.extraPolmonare || caratteristiche.extraPolmonare === "false") && (!caratteristiche.diseminata || caratteristiche.diseminata === "false"))) caratteristiche.corretto[3] = "Campo \"Sede Anatomica (la localizzazione polmonare deve essere sempre barrata anche se secondaria o disseminata)\" mancante";

        if (caratteristiche.extraPolmonare === "true" && !caratteristiche.localizzazione1 && !caratteristiche.localizzazione2) {
            caratteristiche.corretto[4] = "Campo \"Extrapolmonare\" mancante o errato";
        }

    }

    createOggettoBE() {
        let carDiagnosi = this.props.caratteristicheDellaDiagnosiTubercolosi
        let caratteristicheDellaMalattia = JSON.parse(JSON.stringify(this.state.caratteristicheDellaMalattia))
        if (carDiagnosi.esameColturaleEscreato !== "1" && carDiagnosi.esameColturaleAltroMateriale !== "1") {
            caratteristicheDellaMalattia.agenteEziologico = ""
        }

        let caratteristicheDellaMalattiaBe = Utils.removeEmptyValueFromObject(this.pulisciRow(caratteristicheDellaMalattia))
        return Utils.removeFieldFromObject(caratteristicheDellaMalattiaBe, "corretto")
    }

    pulisciRow(caratteristicheDellaMalattia) {

        let objectCaratteristicheDellaMalattia = caratteristicheDellaMalattia

        if (caratteristicheDellaMalattia.localizzazione1 && caratteristicheDellaMalattia.localizzazione2 &&
            caratteristicheDellaMalattia.localizzazione1 === caratteristicheDellaMalattia.localizzazione2) {
            objectCaratteristicheDellaMalattia.localizzazione2 = ""
        } else if (!caratteristicheDellaMalattia.localizzazione1 && caratteristicheDellaMalattia.localizzazione2) {
            objectCaratteristicheDellaMalattia.localizzazione1 = objectCaratteristicheDellaMalattia.localizzazione2
            objectCaratteristicheDellaMalattia.localizzazione2 = ""
        }

        return objectCaratteristicheDellaMalattia
    }

    render() {
        const {t} = this.props

        const caratteristicheDellaMalattiaTubercolosi = (

            <div>
                <h6>{t("SchedaSpecialeTubercolosi.CaratteristicheDellaMalattia")} </h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-lg-8"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.DataInizioTerapiaAntitubercolare")}
                                <span className={styles.mandatoryColor}>*</span>
                                <span
                                    style={{color: "black"}}>{t("SchedaSpecialeTubercolosi.sediagnosipostmortem")}</span>
                            </p>
                            <Calendar
                                id={"dataInizioTerapiaAntitubercolare"}
                                value={this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare}
                                field={"dataInizioTerapiaAntitubercolare"}
                                newCalendar={true}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeTubercolosi.DataInizioTerapiaAntitubercolare"))}
                                error={(this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare === "" || this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.caratteristicheDellaMalattia.dataInizioTerapiaAntitubercolare), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-5"}>
                            <p className={styles.labelHeader} style={{color: "black"}}>
                                {t("SchedaSpecialeTubercolosi.diagnosi")}
                                <span className={styles.mandatoryColor}>*</span></p>
                            <div className={"row"} style={{marginLeft: "1px"}}>
                                <RadioButton id={"diagnosiSi"} name={"diagnosiInPassato"}
                                             label={t("SchedaSpecialeTubercolosi.si")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.caratteristicheDellaMalattia.diagnosiInPassato === "1"}>
                                </RadioButton>
                                <RadioButton id={"diagnosiNo"} name={"diagnosiInPassato"}
                                             label={t("SchedaSpecialeTubercolosi.no")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.caratteristicheDellaMalattia.diagnosiInPassato === "2"}>
                                </RadioButton>
                                <RadioButton id={"diagnosiNonNoto"} name={"diagnosiInPassato"}
                                             label={t("SchedaSpecialeTubercolosi.nonNoto")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true}
                                             value={"3"}
                                             checked={this.state.caratteristicheDellaMalattia.diagnosiInPassato === "3"}>
                                </RadioButton>
                            </div>
                            {this.state.caratteristicheDellaMalattia.diagnosiInPassato === "1" ?
                                <div>
                                    <Calendar
                                        id={"eventualeDataDiagnosiInPassato"}
                                        classes={stylesInput.placeholder}
                                        required={this.state.caratteristicheDellaMalattia.diagnosiInPassato === "1"}
                                        value={this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato}
                                        field={"eventualeDataDiagnosiInPassato"}
                                        newCalendar={true}
                                        onChange={this.riceviValore}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeTubercolosi.dataDiagnosi"))}
                                        error={(this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato === "" || this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.caratteristicheDellaMalattia.eventualeDataDiagnosiInPassato), "-")
                                        }
                                    >
                                    </Calendar>
                                </div> : ""}
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-8"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.classificazione")}</p>
                            <CheckBox
                                id={"classificazioneNuovo"}
                                checked={this.state.caratteristicheDellaMalattia.classificazioneNuovo === "true"}
                                isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                text={t("SchedaSpecialeTubercolosi.NuovoCaso")}
                                onChange={this.riceviValore}
                                newCheckbox={true}
                            >
                            </CheckBox>
                            <CheckBox
                                id={"classificazioneVecchio"}
                                checked={this.state.caratteristicheDellaMalattia.classificazioneVecchio === "true"}
                                isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                text={t("SchedaSpecialeTubercolosi.Recidiva")}
                                onChange={this.riceviValore}
                                newCheckbox={true}
                            >
                            </CheckBox>
                            <CheckBox
                                id={"classificazioneVecchioInterrotto"}
                                checked={this.state.caratteristicheDellaMalattia.classificazioneVecchioInterrotto === "true"}
                                isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                text={t("SchedaSpecialeTubercolosi.RecidivaInterrotto")}
                                onChange={this.riceviValore}
                                newCheckbox={true}
                            >
                            </CheckBox>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-12"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.AgenteEziologico")}
                                {this.props.caratteristicheDellaDiagnosiTubercolosi.esameColturaleEscreato === "1" ||
                                this.props.caratteristicheDellaDiagnosiTubercolosi.esameColturaleAltroMateriale === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                                <span
                                    style={{color: "black"}}>{t("SchedaSpecialeTubercolosi.solocolturapositiva")}</span>
                            </p>
                            <div className={"row"} style={{marginLeft: "1px"}}>
                                <RadioButton id={"agenteEziologico1"} name={"agenteEziologico"}
                                             label={t("SchedaSpecialeTubercolosi.Mtubercolosiscomplex")}
                                             style={{color: "black", fontSize: "14px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "1"}>
                                </RadioButton>
                                <RadioButton id={"agenteEziologico2"} name={"agenteEziologico"}
                                             label={t("SchedaSpecialeTubercolosi.Mtubercolosis")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "2"}>
                                </RadioButton>
                                <RadioButton id={"agenteEziologico3"} name={"agenteEziologico"}
                                             label={t("SchedaSpecialeTubercolosi.Mbovis")}
                                             style={{color: "black", fontSize: "14px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "3"}>
                                </RadioButton>
                                <RadioButton id={"agenteEziologic4"} name={"agenteEziologico"}
                                             label={t("SchedaSpecialeTubercolosi.Mafricanum")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true}
                                             value={"4"}
                                             checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "4"}>
                                </RadioButton>
                                <RadioButton id={"agenteEziologic5"} name={"agenteEziologico"}
                                             label={t("SchedaSpecialeTubercolosi.MnonTubercolare")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "14px"}}
                                             smallLabel={true}
                                             value={"5"}
                                             checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "5"}>
                                </RadioButton>
                            </div>
                            <div className={"row"}>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"agenteEziologicoAltro"} name={"agenteEziologico"}
                                                 label={t("SchedaSpecialeTubercolosi.altro")}
                                                 style={{color: "black", fontSize: "14px"}}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true} value={"6"}
                                                 checked={this.state.caratteristicheDellaMalattia.agenteEziologico === "6"}>
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-4"}>
                                    <Input id={"agenteEziologicoAltro"}
                                           required={this.state.caratteristicheDellaMalattia.agenteEziologico === "6"}
                                           onChange={this.riceviValore}
                                           field={"agenteEziologicoAltro"}
                                           value={this.state.caratteristicheDellaMalattia.agenteEziologicoAltro}
                                           placeholder={t("SchedaSpecialeTubercolosi.altro")}
                                           disabled={this.state.caratteristicheDellaMalattia.agenteEziologico !== "6"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"row"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.sedeAnatomica")}
                                <span className={styles.mandatoryColor}>*</span>
                                <span
                                    style={{color: "black"}}>{t("SchedaSpecialeTubercolosi.localizzazionepolmonare")}</span>
                            </p>
                        </div>
                        <CheckBox id={"polTrachBron"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.caratteristicheDellaMalattia.polTrachBron["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia &&
                                      this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true"}
                                  text={t("SchedaSpecialeTubercolosi.polTrachBron")}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <CheckBox
                                    id={"extraPolmonare"}
                                    checked={this.state.caratteristicheDellaMalattia.extraPolmonare["checked"]}
                                    isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                    required={this.state.caratteristicheDellaMalattia.extraPolmonare === "true"}
                                    defaultChecked={
                                        this.props.segnalazioneCopia.schedaSpeciale &&
                                        this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia &&
                                        this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.extraPolmonare === "true"}
                                    text={t("SchedaSpecialeTubercolosi.extraPolmonare")}
                                    onChange={this.riceviValore}
                                    newCheckbox={true}
                                >
                                </CheckBox>
                            </div>
                            <div className={"col-lg-4"}>
                                <Select
                                    value={this.state.caratteristicheDellaMalattia.localizzazione1}
                                    id={"localizzazione1"}
                                    field={"localizzazione1"}
                                    onChange={this.riceviValore}
                                    newSelect={true}
                                    disabled={this.state.caratteristicheDellaMalattia.extraPolmonare !== "true"}
                                    functionMap={Utils.addFieldToArrayObjects(OggettiUtili.Localizzazione, "codice", "descrizione", "codDesc").sort((a, b) => a.descrizione === "Altre" || a.descrizione === "Non specificata" ? null : a.codDesc > b.codDesc ? 1 : -1).map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                                    })}
                                >
                                </Select>
                            </div>

                        </div>
                        <div className={"row"}>
                            <div className={"col-lg-2"}/>
                            <div className={"col-lg-4"}>
                                <Select
                                    value={this.state.caratteristicheDellaMalattia.localizzazione2}
                                    id={"localizzazione2"}
                                    field={"localizzazione2"}
                                    onChange={this.riceviValore}
                                    newSelect={true}
                                    disabled={this.state.caratteristicheDellaMalattia.extraPolmonare !== "true"}
                                    functionMap={OggettiUtili.Localizzazione.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                                    })}
                                >
                                </Select>
                            </div>
                        </div>
                        <CheckBox id={"diseminata"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.caratteristicheDellaMalattia.diseminata["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia &&
                                      this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.diseminata === "true" ? true : false}
                                  text={t("SchedaSpecialeTubercolosi.Disseminata")}
                                  onChange={this.riceviValore}
                                  parentClass={styles.azTableCellCheckbox}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                    </div>
                </div>
            </div>
        )

        return (
            <div>
                {caratteristicheDellaMalattiaTubercolosi}
            </div>
        );
    }
}

export default withTranslation('common')(CaratteristicheDellaMalattiaTubercolosi)

